export default __webpack_public_path__ + "static/media/Stage.76bc71e1.png";